<template>
  <div class="project-control_points">
    <div class="control_points-actions">
      <div class="control_points-navbar">
        <ccs-input type="text" v-model="search" class="navbar-search"
          iconName="search" placeholder="Начните ввод для поиска" v-if="mode === 'list'"/>
        <ccs-input type="dropdown" class="navbar-mode" :items="modes"
          v-model="mode" placeholder="Выберите поле" :modifiers="['no_cancel']" @select="onModeSelect"/>
        <ccs-input type="dropdown" class="navbar-status" :items="statuses" v-if="mode === 'list'"
          v-model="status" placeholder="Выберите статус"/>
      </div>
      <button v-if="permissionsStatus.isControlPointCreateAllowed"
        class="ccs-button ccs-button--white ccs-button--small" @click="switchModal">
        <img src="@/assets/icons/add.svg" alt="" class="button-icon">
        Новая контрольная точка
      </button>
    </div>
    <div class="control_points-rows" v-if="mode === 'list'">
      <div v-for="controlPoint in controlPoints" :key="`list-${controlPoint.id}`"
        class="control_point"
        :class="{ 'control_point--editable': true }" @click="openControlPointByID(controlPoint.id)">
        <div class="control_point-info">
          <div class="control_point-title">
            {{ controlPoint.name }}
          </div>
          <div class="control_point-date">
            {{ controlPoint.completed_at ? getDisplayText(controlPoint.completed_at) : getDisplayText(controlPoint.expired_at) }}
          </div>
        </div>
        <div class="control_point-responsible">
          <div class="control_point-title">
            Ответственный
          </div>
          <div v-if="!!controlPoint.responsible">
            {{ controlPoint.responsible.full_name }}<br/><br/>
            {{ controlPoint.responsible.email }}
          </div>
          <div v-else>Не назначен</div>
        </div>
        <div class="control_point-tags">
          <div class="control_point-tag ccs-tag ccs-tag--light ccs-tag--primary">
            {{ controlPointStatus[controlPoint.execution_status] }}
          </div>
          <div v-if="controlPoint.type === 'critical'" class="control_point-tag ccs-tag ccs-tag--light">
            Критическая
          </div>
          <div v-else class="control_point-tag ccs-tag ccs-tag--light">
            Функциональная
          </div>
          <div v-if="!controlPoint.completed_at &&
            new Date(controlPoint.expired_at).getTime() - Date.now() < 604800000 &&
            new Date(controlPoint.expired_at).getTime() - Date.now() > 0"
            class="control_point-tag ccs-tag ccs-tag--light ccs-tag--warn">
            Истекает срок
          </div>
          <div v-if="!controlPoint.completed_at && new Date(controlPoint.expired_at).getTime() - Date.now() <= 0"
            class="control_point-tag ccs-tag ccs-tag--light ccs-tag--danger">
            Срок истек
          </div>
        </div>
      </div>
    </div>
    <div class="control_points-board" v-else>
      <div class="board-block">
        <div class="block-title">На рассмотрении</div>
        <div class="control_points">
          <div class="control_point" v-for="controlPoint in waitingForApprovalList" :key="`wfa-${controlPoint.id}`"
            @click="openControlPointByID(controlPoint.id)">
            <div class="control_point-row control_point-row--tags">
              <div v-if="controlPoint.type === 'critical'" class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                Критическая
              </div>
              <div v-else class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                Функциональная
              </div>
              <div v-if="!controlPoint.completed_at &&
                new Date(controlPoint.expired_at).getTime() - Date.now() < 604800000 &&
                new Date(controlPoint.expired_at).getTime() - Date.now() > 0"
                class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--warn ccs-tag--no_action">
                Истекает срок
              </div>
              <div v-if="!controlPoint.completed_at && new Date(controlPoint.expired_at).getTime() - Date.now() <= 0"
                class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--danger ccs-tag--no_action">
                Срок истек
              </div>
            </div>
            <div class="control_point-row">
              <div class="control_point-title">{{ controlPoint.name }}</div>
            </div>
            <div class="control_point-row">
              {{ controlPoint.description }}
            </div>
            <div class="control_point-row">
              <div class="control_point-date">
                {{ controlPoint.completed_at ? getDisplayText(controlPoint.completed_at) : getDisplayText(controlPoint.expired_at) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="board-block">
        <div class="block-title">Выполяются</div>
        <div class="control_points">
          <div class="control_point" v-for="controlPoint in inProgressList" :key="`wfa-${controlPoint.id}`"
            @click="openControlPointByID(controlPoint.id)">
            <div class="control_point-row control_point-row--tags">
              <div v-if="controlPoint.type === 'critical'" class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                Критическая
              </div>
              <div v-else class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                Функциональная
              </div>
              <div v-if="!controlPoint.completed_at &&
                new Date(controlPoint.expired_at).getTime() - Date.now() < 604800000 &&
                new Date(controlPoint.expired_at).getTime() - Date.now() > 0"
                class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--warn ccs-tag--no_action">
                Истекает срок
              </div>
              <div v-if="!controlPoint.completed_at && new Date(controlPoint.expired_at).getTime() - Date.now() <= 0"
                class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--danger ccs-tag--no_action">
                Срок истек
              </div>
            </div>
            <div class="control_point-row">
              <div class="control_point-title">{{ controlPoint.name }}</div>
            </div>
            <div class="control_point-row">
              {{ controlPoint.description }}
            </div>
            <div class="control_point-row">
              <div class="control_point-date">
                {{ controlPoint.completed_at ? getDisplayText(controlPoint.completed_at) : getDisplayText(controlPoint.expired_at) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="board-block">
        <div class="block-title">В процессе закрытия</div>
        <div class="control_points">
          <div class="control_point" v-for="controlPoint in inClosureProcessList" :key="`icpl-${controlPoint.id}`"
            @click="openControlPointByID(controlPoint.id)">
            <div class="control_point-row control_point-row--tags">
              <div v-if="controlPoint.type === 'critical'" class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                Критическая
              </div>
              <div v-else class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                Функциональная
              </div>
            </div>
            <div class="control_point-row">
              <div class="control_point-title">{{ controlPoint.name }}</div>
            </div>
            <div class="control_point-row">
              {{ controlPoint.description }}
            </div>
            <div class="control_point-row">
              <div class="control_point-date">
                {{ controlPoint.completed_at ? getDisplayText(controlPoint.completed_at) : getDisplayText(controlPoint.expired_at) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="board-block">
        <div class="block-title">Выполнены</div>
        <div class="control_points">
          <div class="control_point" v-for="controlPoint in completedList" :key="`wfa-${controlPoint.id}`"
            @click="openControlPointByID(controlPoint.id)">
            <div class="control_point-row control_point-row--tags">
              <div v-if="controlPoint.type === 'critical'" class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                Критическая
              </div>
              <div v-else class="ccs-tag ccs-tag--small ccs-tag--light ccs-tag--no_action">
                Функциональная
              </div>
            </div>
            <div class="control_point-row">
              <div class="control_point-title">{{ controlPoint.name }}</div>
            </div>
            <div class="control_point-row">
              {{ controlPoint.description }}
            </div>
            <div class="control_point-row">
              <div class="control_point-date">
                {{ controlPoint.completed_at ? getDisplayText(controlPoint.completed_at) : getDisplayText(controlPoint.expired_at) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagination :dataFunction="getProjectControlPoints" v-if="mode === 'list'"/>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

import Input from '@/components/forms/Input.vue';
import Pagination from '@/components/Pagination.vue';
import ControlPoint from '@/components/ControlPoint.vue';

export default {
  name: 'ControlPoints',
  components: {
    'ccs-input': Input,
    Pagination,
  },
  data() {
    return {
      mode: 'board',
      statusProp: undefined,
      modes: [{
        prop: 'list',
        text: 'Список'
      }, {
        prop: 'board',
        text: 'Таблица'
      }],
      statuses: [{
        prop: 'waiting_for_approval',
        text: 'Ожидают подтверждения',
      }, {
        prop: 'in_progress',
        text: 'Выполняются'
      }, {
        prop: 'in_closure_process',
        text: 'В процессе закрытия'
      }, {
        prop: 'completed',
        text: 'Завершены'
      }],
      controlPointStatus: {
        waiting_for_approval: 'Ожидает подтверждения',
        in_progress: 'Выполняется',
        in_closure_process: 'В процессе закрытия',
        completed: 'Завершена'
      },
      dateFormatOptions: {
        day: 'numeric',
        year: 'numeric',
        month: 'numeric',
      },
    };
  },
  computed: {
    ...mapState('misc', ['navigation']),
    ...mapState('events', ['event']),
    ...mapState('projects', ['controlPoints']),
    ...mapGetters('projects', [
      'waitingForApprovalList',
      'inProgressList',
      'inClosureProcessList',
      'completedList'
    ]),
    ...mapGetters('session', ['permissionsStatus']),
    defaultActions() {
      return {
        edit: this.permissionsStatus.isControlPointUpdateAllowed,
        delete: this.permissionsStatus.isControlPointDeleteAllowed,
      };
    },
    search: {
      get() {
        return this.navigation.search;
      },
      set(val) {
        this.setSearch(val);
        if (val.length > 3 || val.length === 0) {
          this.getProjectControlPoints();
        }
      },
    },
    status: {
      get() {
        return this.statusProp;
      },
      set(val) {
        if (val !== undefined) {
          this.statusProp = val;
          this.setCustomFilter(`execution_status=${val}`);
          this.getProjectControlPoints();
        } else {
          this.statusProp = val;
          this.setCustomFilter('');
          this.getProjectControlPoints();
        }
      },
    },
  },
  methods: {
    ...mapMutations('misc', ['setSearch', 'setPerPage', 'setPage', 'setCustomFilter']),
    ...mapMutations('projects', ['setControlPoint', 'switchControlPointModal']),
    ...mapActions('misc', ['setDefaultControlPointsView']),
    ...mapActions('projects', ['getProjectControlPoints', 'openControlPointByID']),
    switchModal(controlPoint = undefined) {
      this.switchControlPointModal();
      if (controlPoint) {
        this.setControlPoint(controlPoint);
      }
    },
    getDisplayText(data) {
      let date = new Date(data);
      return date.toLocaleString('ru-RU', this.dateFormatOptions);
    },
    onModeSelect() {
      this.setDefaultControlPointsView(this.mode);
      if (this.mode === 'board') {
        this.setPerPage(50);
        this.status = undefined;
        this.$router.replace({ name: 'project_control_points_board' });
      } else {
        this.setPerPage(15);
        this.status = undefined;
        this.$router.replace({ name: 'project_control_points_list', params: { page: 1 } });
      }
      this.getProjectControlPoints();
    }
  },
  created() {
    if (this.$route.name.indexOf('list') !== -1) {
      this.mode = 'list';
    } else {
      this.setPerPage(50);
    }
    this.getProjectControlPoints();
  }
};
</script>

<style lang="scss" scoped>
::v-deep .control_points-rows .ccs-tag {
  max-width: 180px;
  width: 180px;
}

.project-control_points {
  min-height: 100%;
  min-width: 100%;

  .control_points {

    &-actions{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &-navbar{
      display: flex;
      justify-content: flex-start;
      align-items: center;

      > div:not(:last-child) {
        margin-right: 30px;
      }

    }

    &-rows {

      .control_point {
        box-sizing: border-box;
        margin-top: 20px;
        padding: 20px;
        min-height: 100px;
        width: 100%;
        display: flex;
        align-items: stretch;
        border-radius: 5px;
        box-shadow: 0 0 10px rgba(129, 129, 129, 0.2);

        > div:not(:last-child) {
          margin-right: 30px;
        }

        &--editable {
          cursor: pointer;
        }

        &-title {
          margin-bottom: 10px;
          color: #000;
          font-size: 12px;
          font-weight: bold;
        }

        &-point {
          margin-bottom: 5px;
          color: $primary;
          font-size: 20px;
          font-weight: bold;
        }

        &-date {
          font-size: 12px;
        }

        &-responsible {
          max-width: 300px;
          min-width: 300px;
        }

        &-info {
          max-width: 400px;
          min-width: 400px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;

          .control_point-title {
            color: $primary;
            font-size: 16px;
          }

          .control_point-date {
            font-size: 16px;
          }

        }

        &-tags {
          max-height: 80px;
          display: inline-grid;
          grid-template-rows: 30px 30px;
          grid-auto-columns: 200px;
          grid-auto-flow: column;
          row-gap: 10px;
          column-gap: 5px;
        }

      }

    }

    &-board {
      margin-top: 30px;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;

      .board {

        &-block {
          width: 33%;
          margin: 0 20px;

          &:first-child {
            margin-left: 0;
          }

          &:last-child {
            margin-right: 0;
          }

          .block {

            &-title {
              position: relative;
              padding-bottom: 5px;
              margin-bottom: 20px;
              color: $primary;
              font-size: 20px;

              &::before {
                content: '';
                position: absolute;
                bottom: 0;
                width: 200px;
                height: 1px;
                background: #000;
                border-radius: 5px;
              }

            }

          }

          .control_point {
            padding: 10px;
            margin-bottom: 15px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: stretch;
            border: 1px solid $primary;
            border-radius: 5px;
            cursor: pointer;

            &-row {
              display: flex;
              justify-content: space-between;
              align-items: center;
              flex-wrap: wrap;
              overflow: hidden;

              &:not(:last-child) {
                margin-bottom: 10px;
              }

              &--tags {
                justify-content: flex-start;
              }

            }

            &-title {
              margin-bottom: 5px;
              color: $primary;
            }

          }

        }

      }

    }

  }

  .actions-add {
    margin-bottom: 30px;
  }

}
</style>
